<template>
  <div id="solidBackgroundMapAndHoursComponent" class="solid-background-map-and-hours-component footer-map-component"
    :data-theme="this.$store.state.chosenBrand" data-dark-color-is-primary="false">
    <div class="map-contact">
      <div class="container-fluid map-contact-container">
        <div class="row flex-row align-items-center">
          <div class="col-xs-12 col-md-6 col-content-map">
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJVTN5Ty-NrIkRsduqeoK5jwQ&key=AIzaSyBqmPlt0BmYMsonE4paVkjJjsgW_Bmj-Ic"
                allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
          <div class="col-xs-12 col-md-6 col-content-location-and-hours">
            <div class="content-box">
              <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-12 col-content-location">
                  <div class="row dealer-location-info">
                    <div class="col-xs-12">
                      <h4 class="location-info-heading">Hometown Infiniti</h4>
                      <p class="location-info-address">11550 Common Oaks Drive #204, Raleigh, NC, 27614</p>
                    </div>
                  </div>
                  <div class="row contact-info">
                    <div class="col-xs-12">
                      <a href="#" class="btn contact-link contact-link--directions">
                        <i class="fa fa-map" aria-hidden="true"></i>
                        <span class="sr-only">Get Directions</span>
                      </a>
                      <a href="#" class="btn contact-link contact-link--phone">
                        <i class="fa fa-phone" aria-hidden="true"></i>
                        <span class="sr-only">Call Us</span>
                      </a>
                      <div class="search-bar">
                      <form action="/vehicles" role="search">
                        <div class="input-group"><input aria-label="Search Bar" autocomplete="off" autocorrect="off"
                            class="form-control input-search" data-custom="false" data-placement="bottom"
                            data-search-suggestions="true" data-suggest="true" data-top="2025 INFINITI QX50"
                            name="query" placeholder="Schedule Service" spellcheck="false" title="Search this site..."
                            type="text" value=""><span class="input-group-btn"><button aria-label="search text"
                              class="btn btn-default no-border-left search-submit-btn" type="submit"><i
                                aria-hidden="true" class="fa fa-search"></i><span
                                class="alternate-btn-text hidden">Search</span></button><span
                              aria-label="pause automatic search suggest" aria-pressed="false"
                              class="btn btn-default toggleSearchText visuallyhidden" role="button" tabindex="0"></span></span></div>
                      </form>
                    </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-12 col-content-hours">
                    <div class="row">
                      <div class="col-xs-12 contact-hours">
                        <h5 class="hours-heading">Today's Hours</h5>
                        <p class="current-day-heading">
                          <span class="current-day-name">{{ currentDay }}</span>
                          <span class="spacer">&nbsp;&nbsp;</span>
                          <i class="fa fa-clock-o" aria-hidden="true"></i>
                        </p>
                        <p class="current-day-hours">
                          <span class="nav-hour nav-hour--sales">
                            <span class="category-delimiter"></span>
                            <span class="category-name">Sales</span>
                            <span class="hour hour-open">9</span>
                            <span class="field-delimiter"> - </span>
                            <span class="hour hour-close">7</span>
                          </span>
                          <span class="nav-hour nav-hour--service">
                            <span class="category-delimiter"></span>
                            <span class="category-name">Service</span>
                            <span class="hour hour-open">7:30</span>
                            <span class="field-delimiter"> - </span>
                            <span class="hour hour-close">5</span>
                          </span>
                        </p>
                        <a href="#" class="btn utility-link view-all-hours-link">
                          <span class="utility-link-text">Weekly Hours</span>
                          <span class="spacer">&nbsp;&nbsp;</span>
                          <i class="fa fa-chevron-right" aria-hidden="true"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";
</script>

<script>
  export default {
    name: "DayOfWeek",
    computed: {
      currentDay() {
        const days = [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ];
        return days[new Date().getDay()];
      },
    },
  };
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>

  .contact-hours {
    padding: 0;
  }

  /* Custom Properties */

  .solid-background-map-and-hours-component {
    --pc: var(--primary-color, #333333);
    --pcd: var(--primary-dark, #000000);
    --pcl: var(--primary-light, #ffffff);
  }

  /* Utilities */

  .solid-background-map-and-hours-component .btn {
    -moz-transition: all 0.3s ease;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }

  .solid-background-map-and-hours-component .utility-link {
    color: #ffffff;
    color: var(--pcl, #ffffff);
    border: 0;
    border-radius: 0;
    border-bottom: solid 1px;
    border-bottom-color: #ffffff;
    border-bottom-color: var(--pcl, #ffffff);
    padding: 5px 0;
  }

  .solid-background-map-and-hours-component .utility-link:hover, 
  .solid-background-map-and-hours-component .utility-link:active, 
  .solid-background-map-and-hours-component .utility-link:focus {
    opacity: 0.7;
  }

  .solid-background-map-and-hours-component .flex-row {
    display: flex;
    flex-wrap: wrap;
  }
  
  .solid-background-map-and-hours-component .align-items-center {
    align-items: center;
  }

  /* General */

  .solid-background-map-and-hours-component .map-contact {
    background-color: #333333;
    background-color: var(--pc);
    color: #ffffff;
    color: var(--pcl, #ffffff);
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .solid-background-map-and-hours-component .map-contact-container {
    max-width: 1400px;
  }

  .solid-background-map-and-hours-component .map-contact .content-box {
    padding: 30px 0;
    margin: auto;
  }

  .solid-background-map-and-hours-component .map-contact h4,
  .solid-background-map-and-hours-component .map-contact h5,
  .solid-background-map-and-hours-component .map-contact .contact-link {
    text-transform: uppercase;
    font-family: var(--heading-text) !important;
  }

  .solid-background-map-and-hours-component .map-contact p,
  .solid-background-map-and-hours-component .map-contact .contact-link {
    font-size: 13px;
    font-weight: 400;
  }

  .solid-background-map-and-hours-component .map-contact .location-info-address {
    margin: 15px 0px;
  }

  .solid-background-map-and-hours-component .map-contact .hours-heading {
    margin-top: 30px;
  }

  .solid-background-map-and-hours-component .map-contact .contact-hours p, 
  .solid-background-map-and-hours-component .map-contact h4 {
    margin-bottom: 5px;
  }

  .solid-background-map-and-hours-component .nav-hour, 
  .solid-background-map-and-hours-component .nav-hour:not(:first-child) .category-delimiter {
    margin-right: 7px;
  }

  .solid-background-map-and-hours-component .nav-hour {
    display: inline-block;
  }

  .solid-background-map-and-hours-component .nav-hour span:not(.category-name) {
    font-size: 16px;
  }

  .solid-background-map-and-hours-component .nav-hour .category-name {
    color: #ffffff;
    color: var(--pcl, #ffffff);
    opacity: 0.7;
    padding-right: 5px;
  }

  .solid-background-map-and-hours-component .contact-link, 
  .solid-background-map-and-hours-component .search-bar {
    margin-bottom: 10px;
  }

  .solid-background-map-and-hours-component .contact-link {
    padding: 9px 10px 7px 10px;
    margin-right: 10px;
    color: #ffffff;
    color: var(--pcl, #ffffff);
    border: solid 1px;
    border-color: #ffffff;
    border-color: var(--pcl, #ffffff);
    border-radius: 100%;
  }

  .solid-background-map-and-hours-component .contact-link:hover, 
  .solid-background-map-and-hours-component .contact-link:active, 
  .solid-background-map-and-hours-component .contact-link:focus {
    color: #333333;
    color: var(--pc);
    background-color: #ffffff;
    background-color: var(--pcl, #ffffff);
  }

  .solid-background-map-and-hours-component .contact-link .fa {
    font-size: 17px;
  }

  .solid-background-map-and-hours-component .view-all-hours-link {
    margin-top: 15px;
  }

  .solid-background-map-and-hours-component .view-all-hours-link .fa {
    font-size: 11px;
  }

  /* Search Bar */

  .solid-background-map-and-hours-component .search-bar {
    display: inline-block;
    vertical-align: middle;
  }

  .solid-background-map-and-hours-component .search-bar .input-search {
    background-color: transparent;
    color: #ffffff;
    color: var(--pcl, #ffffff);
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
  }

  .solid-background-map-and-hours-component .search-bar .input-search::placeholder {
    color: #ffffff;
    color: var(--pcl, #ffffff);
  }

  .solid-background-map-and-hours-component .search-bar .input-group-btn .search-submit-btn {
    background-color: transparent;
    color: #ffffff;
    color: var(--pcl, #ffffff);
  }

  .solid-background-map-and-hours-component .search-bar .input-group-btn .search-submit-btn:hover, 
  .solid-background-map-and-hours-component .search-bar .input-group-btn .search-submit-btn:active, 
  .solid-background-map-and-hours-component .search-bar .input-group-btn .search-submit-btn:focus {
    color: #333333;
    color: var(--pc);
    background-color: #ffffff;
    background-color: var(--pcl, #ffffff);
  }

  .solid-background-map-and-hours-component .search-bar .input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
  }

  .solid-background-map-and-hours-component .search-bar .input-search, 
  .solid-background-map-and-hours-component .search-bar button {
    font-size: 14px;
    height: 40px;
    border-color: #ffffff;
    border-color: var(--pcl, #ffffff);
  }
  span.btn.btn-default.toggleSearchText.visuallyhidden {
    display: none;
  }

  @media (min-width: 992px) {
    
    .solid-background-map-and-hours-component .map-contact .content-box {
      padding: 30px;
      max-width: 460px;
    }

  }

  @media (min-width: 768px) and (max-width: 991px) {

    .solid-background-map-and-hours-component .map-contact .hours-heading {
      margin-top: 10px;
    }

    .solid-background-map-and-hours-component .view-all-hours-link {
      margin-top: 0;
    }

  }

  @media (max-width: 991px) {
    
    .solid-background-map-and-hours-component .nav-hour .category-delimiter {
      display: none;
    }

  }
</style>